import React from 'react';
import "./highlight.css";
import Modal from '../../modal';

class Highlight extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false
        };
    }

    openModal = () => {
        this.setState({ isModalOpen: true });
    };

    closeModal = () => {
        this.setState({ isModalOpen: false });
    };

    render() {
        const highlightContent = (
            <div className="highlight">
                <p className="highlight-text">{this.props.text}</p>
                {this.props.secondText && (
                    <p className="highlight-text">{this.props.secondText}</p>
                )}
            </div>
        );

        // If link prop is provided, render as anchor tag
        if (this.props.link) {
            return (
                <a 
                    href={this.props.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="highlight-wrapper highlight-clickable highlight-link"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {highlightContent}
                </a>
            );
        }

        // Otherwise, render as clickable div for modal or non-interactive
        return (
            <>
                <div 
                    className={`highlight-wrapper ${this.props.modalContent ? 'highlight-clickable' : ''}`}
                    onClick={this.props.modalContent ? this.openModal : undefined}
                >
                    {highlightContent}
                </div>
                
                {this.props.modalContent && (
                    <Modal 
                        isOpen={this.state.isModalOpen} 
                        onClose={this.closeModal}
                    >
                        {this.props.modalContent}
                    </Modal>
                )}
            </>
        );
    }
}

export default Highlight;